import { BaseQueryApi } from "@reduxjs/toolkit/query";
import { getLoggedUser } from "../../utils/helpers/tokenStorage";
import { setHeaderContentType } from "./setHeaderContentType";

const prepareHeaders = (
  headers: Headers,
  {
    endpoint,
  }: Pick<BaseQueryApi, "getState" | "extra" | "endpoint" | "type" | "forced">
) => {
    const authToken = getLoggedUser()?.token;

    if (authToken && endpoint !== "login") {
      headers.set("authorization", `Bearer ${authToken}`);
      headers.set("X-Requested-With", "XMLHttpRequest");
    }

    setHeaderContentType(headers, endpoint);

    return headers;
};

export default prepareHeaders;